import { render, staticRenderFns } from "./index.vue?vue&type=template&id=43ee55af&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&id=43ee55af&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43ee55af",
  null
  
)

/* custom blocks */
import block0 from "@/translations/FinLexiconEntryNotFound.json?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Fcodebuild%2Foutput%2Fsrc665095227%2Fsrc%2Ffincraft-app%2Fsrc%2Fcomponents%2Fcommon%2Flexicon%2FLexiconEntryNotFound%2Findex.vue"
if (typeof block0 === 'function') block0(component)

export default component.exports